import { useLingui } from "@lingui/react/macro";
import { PlusCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AddStepButtonProps {
  onClick: () => void;
}

export function AddStepButton({ onClick }: AddStepButtonProps) {
  const { t } = useLingui();

  return (
    <Button
      variant="ghost"
      onClick={onClick}
      className="h-28 w-full flex-col gap-2 rounded-[10px] border border-dashed border-(--color-border-strong) bg-(--color-surface-muted) p-3 hover:bg-(--color-surface-accent)"
    >
      <PlusCircle className="size-6 text-(--color-text-secondary)" />
      <div>
        <p className="text-base font-medium text-(--color-text-primary)">{t`Add another step`}</p>
        <p className="text-sm text-(--color-text-secondary)">{t`Click to add a new execution step`}</p>
      </div>
    </Button>
  );
}
